var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinglePhase01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.92,13.72c-3.11,0-5.65-2.53-5.65-5.65s2.53-5.65,5.65-5.65s5.65,2.53,5.65,5.65S12.04,13.72,8.92,13.72z  M8.92,2.92c-2.84,0-5.15,2.31-5.15,5.15s2.31,5.15,5.15,5.15c2.84,0,5.15-2.31,5.15-5.15S11.76,2.92,8.92,2.92z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.26,
    y: 7.75,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.0231 8.702)",
    className: "st2",
    width: 15.46,
    height: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.07,9.07H1.65V6.4c-0.1,0.1-0.23,0.19-0.4,0.29C1.09,6.78,0.95,6.85,0.81,6.9V6.5 c0.23-0.11,0.44-0.24,0.62-0.4c0.18-0.16,0.3-0.31,0.37-0.46h0.27V9.07z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePhase01);
export default __webpack_public_path__ + "static/media/SinglePhase-01.db2ce34148b551bc832650babff04c4b.svg";
export { ForwardRef as ReactComponent };